/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffectOnce } from '@/hooks';
import { FullpageLoading, Wrong } from '@/components';
import { PRODUCT_TYPE, PRODUCT_NAME_FOR_WFP } from '@constants';
import useConnectionContext from '@hooks/useConnectionContext';
import { getPolicyDetailData } from './getPolicyDetail';
import { PolicyDetailAssurance } from './PolicyDetailAssurance';
import { PolicyDetailClaim } from './PolicyDetailClaim';
import { PolicyDetailCoverage } from './PolicyDetailCoverage';
import { PolicyDetailHeader } from './PolicyDetailHeader';

import classes from './index.module.css';

const EMPTY_TITLE = 'Oops!';
const EMPTY_TEXT = 'Something went wrong.\nWe can\'t seem to find the page you\'re looking for.';

export default function Page() {
  const { pathname, state } = useLocation();
  const [policyDetail, setPolicyDetail] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  // return assurance | buyer protection
  const { type = PRODUCT_TYPE.Return, policyType: listPolicyType } = state || {};
  const { store: { name } } = useConnectionContext();
  useEffectOnce(async () => {
    const paths = pathname.split('/');
    const policyId = paths[paths.length - 1];

    const detail = await getPolicyDetailData({
      policyId,
      policyType: listPolicyType,
    });
    setPolicyDetail(detail);
    setIsLoading(false);
  }, []);

  const detail = React.useMemo(() => policyDetail, [policyDetail]);
  const { policyType } = detail || {};

  // 接口返回了policyType时，取接口返回的type
  const getDetailType = (param = '') => {
    let detailType;
    if (param.indexOf('ra') > -1) {
      detailType = PRODUCT_TYPE.Return;
    } else if (param.indexOf('bp') > -1) {
      detailType = PRODUCT_TYPE.Buyer;
    } else if (param.indexOf('as') > -1) {
      detailType = PRODUCT_TYPE.Assured;
    } else if (PRODUCT_NAME_FOR_WFP.includes(param)) {
      detailType = PRODUCT_TYPE.WorryPurchase;
    } else {
      detailType = type;
    }
    return detailType;
  };
  const detailType = getDetailType(policyType?.toLocaleLowerCase()); // 由于Shopify policyType=RA
  return (
    isLoading ? <FullpageLoading />
      : (
        <div className={classes.main}>
          {!detail ? <Wrong title={EMPTY_TITLE} text={EMPTY_TEXT} btnLink="/policies" /> : null}
          <PolicyDetailHeader policyDetail={detail} />
          <PolicyDetailAssurance policyDetail={detail} type={detailType} platform={name} />
          <PolicyDetailCoverage policyDetail={detail} />
          <PolicyDetailClaim policyDetail={detail} type={detailType} platform={name} />
        </div>
      )
  );
}
